export const regionFlagMap: Record<string, string> = {
  Colorado: '/auth/colorado.png',
  Wyoming: '/auth/wyoming.png',
  Utah: '/auth/utah.png',
  Montana: '/auth/montana.png',
  California: '/auth/california.png',
  Idaho: '/auth/wyoming.png',
  Gujarat: '/auth/colorado.png',
  Other: '/auth/colorado.png',
}
